'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventEmitter = require('../../Base/views/eventEmitter.c');

var _eventEmitter2 = _interopRequireDefault(_eventEmitter);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dataModel = require('../../../common/backbone/dataModel');

var _dataModel2 = _interopRequireDefault(_dataModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_EventEmitter) {
    _inherits(_class, _EventEmitter);

    function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
        key: 'setState',


        /**
         * override
         * ensure that setState called on mounted component
         * @param {object} state
         * @param {function} [cb]
         * @return {Promise}
         */
        value: function setState(state, cb) {
            var _this2 = this;

            if (!this.isUnmounted) {
                if (typeof cb === 'function') {
                    return _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'setState', this).call(this, state, cb);
                } else {
                    return new Promise(function (resolve, reject) {
                        _get(_class.prototype.__proto__ || Object.getPrototypeOf(_class.prototype), 'setState', _this2).call(_this2, state, function () {
                            return resolve();
                        });
                    });
                }
            } else {
                return Promise.resolve();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // flag for unmounted components
            this.isUnmounted = true;
            this.stopListening();
            this.off();
        }
    }, {
        key: 'render',
        value: function render() {
            if (typeof this.template === 'function') {
                return this.template.call(this);
            } else {
                return _react2.default.createElement('span', null);
            }
        }
    }, {
        key: 'compileStyle',
        value: function compileStyle(styleSheet) {
            var styleHash = '';

            /**
             * уникальный хэш набора стилей для того что бы aphrodite не компилил стили при каждом рендере
             * необходимо определять там, где стиль вычисляются на основе props или state.
             */
            if (typeof this.computeStyleHash === 'function') {
                styleHash = this.computeStyleHash();
            }

            if (!this._styleHash || this._styleHash !== styleHash) {
                this._styleHash = styleHash;

                if (typeof styleSheet === 'function') {
                    this._classList = styleSheet.call(this, Object.assign({}, this.props.theme || {}), this.props, this.state || {});
                } else {
                    this._classList = {};
                }
            }

            return this._classList;
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return '';
        }

        /**
         * подготавливает список элементов на основе коллекции
         * @param {object} collection
         * @return {*|Array}
         * @private
         */

    }, {
        key: '_prepareList',
        value: function _prepareList() {
            var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var result = collection.models || collection;

            if (_react2.default.isValidElement(result)) {
                result = _react2.default.Children.toArray(result);
            }

            result = result.map(function (item) {
                // already transformed by processor to React element
                if (_react2.default.isValidElement(item)) {
                    return {
                        id: item.props.value,
                        stringName: item.props.name,
                        name: item
                    };

                    // plain value in array
                } else if (typeof item === 'string' || typeof item === 'number') {
                    return {
                        id: item,
                        name: item,
                        stringName: item
                    };
                } else if (item instanceof _dataModel2.default) {
                    var name = typeof item.name === 'function' && item.name() || item.get('name') || item.id || '';

                    return {
                        id: item.id,
                        name: name,
                        stringName: name
                    };

                    // plain object
                } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
                    return {
                        id: item.id,
                        name: item.name || item.id || '',
                        stringName: item.name || item.id || ''
                    };
                }
            });

            return result;
        }
    }, {
        key: '_processCollection',
        value: function _processCollection(collection) {
            var result = collection;

            if (typeof this.props.processor === 'function') {
                result = this.props.processor(collection.models || collection);
            }

            return result;
        }
    }]);

    return _class;
}(_eventEmitter2.default);

_class.displayName = 'Component';
exports.default = _class;